import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { t } from "ttag";
import { ChevronLeft, IconButton } from "@coolremote/shared";
import { CustomerNameForm } from "../NewUserFlow/CustomerNameStep";
import { createCustomerFromDevice } from "./existingUserFlowApi";
import { ExistingUserFlowState, isLoggedIn } from "./existingUserFlowState";
import parentStyles from "../DeviceRegistrationPublic.module.css";
import styles from "./ExistingUserFlow.module.css";

/**
 * "+ Create new customer" sub-step off Select Customer (CM-619). Reuses
 * `CustomerNameForm` from the new-user branch as-is, per its own doc comment.
 * A route of its own (not a dialog) so back-button behaviour matches the rest
 * of this flow; on save it goes straight on to Select Site with the new
 * customer already selected, rather than back through Select Customer.
 */
const NewCustomerStep: React.FC = () => {
  const history = useHistory<ExistingUserFlowState | undefined>();
  const deviceState = history.location.state;

  useEffect(() => {
    if (!isLoggedIn(deviceState)) {
      history.replace("/register-device/existing-user");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!isLoggedIn(deviceState)) {
    return null;
  }

  const handleBack = () => {
    history.goBack();
  };

  const handleSubmit = (customerName: string) => {
    createCustomerFromDevice(deviceState.serial, deviceState.pin, customerName).then(({ customerId, name }) => {
      const nextState = { ...deviceState, customerId, customerName: name } as ExistingUserFlowState;
      // Attach the created customer to *this* history entry too, so that going
      // back from Select Site lands here with the choice restored.
      history.replace(history.location.pathname, nextState);
      history.push("/register-device/existing-user/select-site", nextState);
    });
  };

  return (
    <div className={parentStyles.screen}>
      <div className={parentStyles.appBar}>
        <IconButton className={parentStyles.backButton} onClick={handleBack} aria-label={t`Back`}>
          <ChevronLeft width={20} height={20} />
        </IconButton>
        <span className={parentStyles.appBarTitle}>{t`New Customer`}</span>
        <span />
      </div>

      <div className={styles.stepContent}>
        <CustomerNameForm submitLabel={t`Save`} onSubmit={handleSubmit} />
      </div>
    </div>
  );
};

export default NewCustomerStep;
